import React from 'react';
import { motion } from 'framer-motion';
import { CompassIcon, CpuIcon, GemIcon, GraduationCapIcon } from 'lucide-react';
const PILLARS = [{
  icon: CompassIcon,
  title: 'Marketing Estratégico',
  description: 'Decisiones basadas en estrategia, no en tendencias. Cada recurso parte de un objetivo claro.'
}, {
  icon: CpuIcon,
  title: 'Inteligencia Artificial',
  description: 'Integramos IA de forma útil y aplicada, para acelerar el trabajo real de cada día.'
}, {
  icon: GemIcon,
  title: 'Productos Digitales Premium',
  description: 'Diseño cuidado, estructura clara y calidad de estudio en cada eBook, plantilla y sistema.'
}, {
  icon: GraduationCapIcon,
  title: 'Aprendizaje Práctico',
  description: 'Explicaciones directas y accionables: entendés el porqué y sabés exactamente qué hacer después.'
}];
const ease = [0.22, 1, 0.36, 1] as const;
export function Philosophy() {
  return <section aria-labelledby="filosofia-title" className="relative w-full overflow-hidden border-t border-ink/[0.07] bg-paper-alt py-28 sm:py-32 lg:py-44" data-id="element-211" data-mp="17becwkqwpkam">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-212" data-mp="137q6i5e0guqy">
        <div className="absolute left-1/2 top-0 h-[520px] w-[900px] -translate-x-1/2 rounded-full blur-[120px]" style={{
        background: 'radial-gradient(circle at 38% 40%, rgba(37,99,246,0.10), transparent 62%), radial-gradient(circle at 66% 58%, rgba(122,77,255,0.10), transparent 62%)'
      }} data-id="element-213" data-mp="1h0plm69vsmxz" />
      </div>

      <div className="relative mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-214" data-mp="yazq1gyanx50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease
      }} className="mx-auto max-w-3xl text-center" data-id="element-215" data-mp="tbmw6c909psx">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-ink-muted" data-id="element-216" data-mp="24swaylh6vtnw">
            Nuestra filosofía
          </p>
          <h2 id="filosofia-title" className="mt-7 text-3xl font-semibold leading-[1.15] tracking-[-0.025em] text-ink sm:text-[2.9rem]" data-id="element-217" data-mp="2gsjtl2stoepp">
            Más que productos digitales.
            <span className="mt-2 block gradient-text" data-id="element-218" data-mp="2qriufz7cj625">
              Un ecosistema para crecer.
            </span>
          </h2>
          <p className="mx-auto mt-9 max-w-2xl text-[16px] font-light leading-relaxed text-ink-soft" data-id="element-219" data-mp="1t53bsu36o2d0">
            Creemos que los mejores productos digitales combinan estrategia,
            tecnología y ejecución práctica.
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-[16px] font-light leading-relaxed text-ink-soft" data-id="element-220" data-mp="27semktrjjic2">
            Cada eBook, plantilla, recurso de IA y herramienta que creamos está
            pensado para que emprendedores y empresas ganen tiempo, tomen
            mejores decisiones y obtengan resultados reales.
          </p>
        </motion.div>

        <ul className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-24 lg:grid-cols-4" data-id="element-221" data-mp="17r9ouz9dg8ds">
          {PILLARS.map((pillar, i) => <motion.li key={pillar.title} initial={{
          opacity: 0,
          y: 22
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-70px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.08,
          ease
        }} className="group relative overflow-hidden rounded-3xl border border-ink/[0.07] bg-white p-9 shadow-soft transition-shadow duration-300 hover:shadow-card sm:p-10" data-id="element-222" data-mp="12rnfx20kteas" data-mpi={i}>
              <span aria-hidden="true" className="absolute -left-12 -top-12 h-32 w-32 rounded-full border border-violetd/10" data-id="element-223" data-mp="f4f8oejl7v64" />
              <span className="relative grid h-12 w-12 place-items-center rounded-2xl border border-ink/[0.07] bg-paper-alt" data-id="element-224" data-mp="55ziqewaqry7">
                <pillar.icon aria-hidden="true" className="h-5 w-5 text-violetd" strokeWidth={1.6} data-id="element-225" data-mp="14nzqs7xh4yz" />
              </span>
              <h3 className="relative mt-8 text-[17px] font-semibold leading-snug tracking-tight text-ink" data-id="element-226" data-mp="usk4vq3uwvfp">
                {pillar.title}
              </h3>
              <p className="relative mt-4 text-[14px] font-light leading-relaxed text-ink-muted" data-id="element-227" data-mp="l3ttxoqu9x4k">
                {pillar.description}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}